module.exports = __webpack_public_path__ + "img/ad5a7d34c8ff5cde02483315e4e8a227.svg";